import { render } from "./CalendarNewSlotModal.vue?vue&type=template&id=c53c2afe&scoped=true&ts=true"
import script from "./CalendarNewSlotModal.vue?vue&type=script&lang=ts"
export * from "./CalendarNewSlotModal.vue?vue&type=script&lang=ts"

import "./CalendarNewSlotModal.vue?vue&type=style&index=0&id=c53c2afe&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53c2afe"]])

export default __exports__